const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      const element = document.querySelector('.shopify-app-block .yotpo-widget-instance');
      const trigger = document.querySelector('.yotpo-trigger');
      if (trigger != null && element != null) {
        trigger.addEventListener('click', () => {
          const rect = element.getBoundingClientRect();
          let offsetTop = rect.top + document.body.scrollTop - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        });
      }
      if(document.querySelectorAll('.product-thumb--image').length > 0) {
        document.querySelectorAll('.product-thumb--image').forEach(function(target) {
          target.addEventListener('click', (event) => {
            event.preventDefault();
            setTimeout(function() {
              document.querySelectorAll('.product-thumb--image').forEach(function(targetT) {
                targetT.classList.remove('swiper-slide-thumb-active');
              });
              target.classList.add('swiper-slide-thumb-active');
            }, 200);
            var swiper = new Swiper('.product-carousel');
            swiper.slideTo(event.target.closest('.product-thumb--image').getAttribute('data-index'));
          });
        });
      }
      
      if(document.querySelectorAll('.learn_more').length > 0) {
      
        const learnMoreButton = document.querySelector('.learn_more');
      
        if (learnMoreButton) {
          learnMoreButton.addEventListener('click', function() {
            // Find the parent element
            const parentElement = learnMoreButton.closest('.product_info');
      
            if (parentElement) {
              // Toggle the class on the parent element
              parentElement.classList.toggle('expanded');
      
              // Get the "Learn More" and "Learn Less" text from data attributes
              const learnMoreText = learnMoreButton.getAttribute('data-learn-more');
              const learnLessText = learnMoreButton.getAttribute('data-learn-less');
      
              // Change the button text based on the presence of the 'expanded' class
              if (parentElement.classList.contains('expanded')) {
                learnMoreButton.textContent = learnLessText;
              } else {
                learnMoreButton.textContent = learnMoreText;
              }
            }
          });
        }
      }
      

      
    }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
